import React from "react";
import PropTypes from 'prop-types';
import Downshift from "downshift";
import {Icon} from "spectre-react/dist/cjs";
import {GroupedSelectMenu, PlainSelectMenu} from "./menu";
import {escapeRegexCharacters} from "../utils";


class SingleSelect extends React.PureComponent { // searchable, grouped
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.object),
        itemToString: PropTypes.func,
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        selectedItem: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        searchable: PropTypes.bool,
        clearable: PropTypes.bool,
        grouped: PropTypes.bool,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        items: [],
        itemToString: (obj) => (obj ? obj.label : ''),
        selectedItem: null,
        searchable: false,
        clearable: true,
        grouped: false,
        disabled: false,
        className: 'form-input',
        placeholder: 'Select...'
    };

    state = {inputValue: ''};

    onChange = (selectedItem) => this.props.onChange({target: {name: this.props.name, value: selectedItem}});

    onStateChange = (changes, stateAndHelpers) => {
        switch (changes.type) {
            case Downshift.stateChangeTypes.clickItem:
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.keyDownEscape:
            case Downshift.stateChangeTypes.mouseUp:
                this.setState({inputValue: ''});
                return;
            case Downshift.stateChangeTypes.changeInput:
                this.setState({inputValue: stateAndHelpers.inputValue});
                return;
        }
    };

    stateReducer = (state, changes) => {
        switch (changes.type) {
            case Downshift.stateChangeTypes.keyDownEscape:
            case Downshift.stateChangeTypes.mouseUp:
                const selectedItem = state.selectedItem;
                const inputValue = this.props.itemToString(selectedItem);
                return {...changes, selectedItem, inputValue};
            default:
                return changes;
        }
    };

    getItems = () => {
        const escapedValue = escapeRegexCharacters(this.state.inputValue.trim());
        if (escapedValue === '') return this.props.items;

        const itemToString = this.props.itemToString;
        const re = new RegExp(escapedValue, 'i');

        if (this.props.grouped)
            return this.props.items
                .map(section => ({
                    label: section.label,
                    items: section.items.filter(item => re.test(itemToString(item)))
                }))
                .filter(section => section.items.length > 0);
        else
            return this.props.items.filter(item => re.test(itemToString(item)));
    };

    render() {
        const {itemToString, selectedItem, searchable, clearable, placeholder, className, name, disabled} = this.props;
        const id = this.props.id || name;
        const matchingItems = this.getItems();
        const Menu = this.props.grouped ? GroupedSelectMenu : PlainSelectMenu;

        return (
            <Downshift itemToString={itemToString} selectedItem={selectedItem}
                       stateReducer={this.stateReducer} onStateChange={this.onStateChange} onChange={this.onChange}
            >
                {({
                      getMenuProps, getInputProps, getItemProps, isOpen, highlightedIndex, selectedItem,
                      clearSelection, toggleMenu
                  }) =>
                    <div className="custom-select">
                        <div className="has-icon-right">
                            <input {...getInputProps({
                                id, className, onClick: toggleMenu, readOnly: !searchable,
                                disabled, name, placeholder
                            })}/>
                            {selectedItem && clearable
                                ? <Icon formIcon icon="cross" onClick={disabled ? undefined : clearSelection}/>
                                : <Icon formIcon icon={isOpen ? "arrow-up" : "arrow-down"}/>}
                        </div>

                        {isOpen && matchingItems.length > 0 &&
                            <Menu matchingItems={matchingItems} getMenuProps={getMenuProps} getItemProps={getItemProps}
                                  highlightedIndex={highlightedIndex} selectedItems={selectedItem}
                                  itemToString={itemToString}
                                  multi={false}
                            />
                        }
                    </div>}
            </Downshift>
        );
    }
}

export default SingleSelect;